import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/lantern/restart/init', method: 'GET', params }, { interceptResultCode: false });
};
//帮助页 初始化
export const onGetInitHelpDataAPI = (params) => {
  return axios({ url: '/lantern/restart/help', method: 'GET', params }, { interceptResultCode: false });
};
//帮助页 助力
export const help = (params) => {
  return axios({ url: '/lantern/restart/help', method: 'POST', params }, { interceptResultCode: false });
};
// 产生任务3访问论坛奖励
export const doTaskThree = (params) => {
  return axios({ url: '/lantern/restart/task', method: 'POST', params }, { interceptResultCode: false });
};
// 抽奖
export const lottery = (params) => {
  return axios({ url: '/lantern/restart/lottery', method: 'POST', params }, { interceptResultCode: false });
};
// 领取奖励
export const reward = (params) => {
  return axios({ url: '/lantern/restart/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 领取任务奖励
export const taskReward = (params) => {
  return axios({ url: '/lantern/restart/task/get', method: 'POST', params }, { interceptResultCode: false });
};





// WEBPACK FOOTER //
// ./src/pages/tideng/third/api.js